module.exports = __webpack_public_path__ + "static/media/mastercard.b4e311b0.svg";